// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 940 ? "gallery-edit" : chunkId) + "." + {"305":"58967b2d","940":"afe4a164"}[chunkId] + ".css";
};